import { getHubsSignupCTA } from 'pricing-pages-lib/utils/publicPageUrls';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { productForSkuIdSelector, productSelector, skuSelector } from './ProductsSelectors';
export const productNamesByProductLevelMapSelector = (state, {
  productLine
}) => {
  return currentOrderedPaidProductLevels.reduce((acc, productLevel) => {
    const product = productSelector(state, {
      productLine,
      productLevel
    });
    if (!product) return acc;
    acc[productLevel] = product.apiName;
    return acc;
  }, {});
};
export const hubsSignupCTASelector = (state, {
  skuId,
  nonMerchandiseIdProduct,
  ctaType,
  sourceId,
  pathname,
  isAppReady
}) => {
  if (!isAppReady && !nonMerchandiseIdProduct) return '';
  if (!skuId) {
    return getHubsSignupCTA({
      pathname,
      ctaType,
      sourceId,
      nonMerchandiseIdProduct
    });
  }
  const {
    productLine,
    productLevel,
    apiName
  } = productForSkuIdSelector(state, {
    skuId
  });
  return getHubsSignupCTA({
    pathname,
    ctaType,
    sourceId,
    nonMerchandiseIdProduct,
    productLine,
    productLevel,
    apiName
  });
};
export const trackingProductNameSelector = (state, {
  skuId
}) => {
  const sku = skuSelector(state, {
    skuId
  });
  if (sku.skuType === QUANTITY_PACK) {
    return `${sku.quantityPackApiName}_${sku.productApiName}`;
  }
  return productForSkuIdSelector(state, {
    skuId
  }).apiName;
};